import React, { useState } from 'react';
type TabType = 'prediabetes' | 'diabetes' | 'familiar' | 'prevencion' | 'cardio';
export function ReviewsSection() {
  const [activeTab, setActiveTab] = useState<TabType>('prediabetes');
  const testimonials = {
    prediabetes: {
      name: 'María Elena R.',
      meta: '58 años, Houston TX',
      text: "Mi doctor me dijo 'prediabetes' y yo no sabía ni qué significaba. Este libro me explicó en una tarde lo que nadie me había explicado en 3 consultas. Ahora entiendo mis números, sé leer etiquetas y llevo 6 semanas aplicando el orden del plato. Mi último análisis mejoró."
    },
    diabetes: {
      name: 'Carlos M.',
      meta: '62 años, Miami FL',
      text: "Llevo 8 años con diabetes tipo 2. He leído de todo. Este ebook es diferente porque no te dice 'deja de comer esto'. Te explica QUÉ PASA DENTRO de tu cuerpo y por qué. La parte de la glicación me abrió los ojos. Ahora camino 10 minutos después de cada comida y uso el mecanismo de rescate."
    },
    familiar: {
      name: 'Ana Lucía V.',
      meta: '44 años, Los Angeles CA',
      text: 'Mi papá perdió la vista por diabetes. Mi mamá está en diálisis. Compré este libro porque no quiero ese futuro. Los 56 nombres del azúcar oculto los tengo en mi teléfono y los consulto cada vez que voy al supermercado.'
    },
    prevencion: {
      name: 'Roberto D.',
      meta: '51 años, Chicago IL',
      text: 'Tengo 51 años y mi familia tiene historial de diabetes. Compré el ebook como prevención. Lo mejor: no es alarmista — te da herramientas. El plan de 14 días lo hice completo. Más energía, menos bajones, y ahora sé exactamente por qué funciona cada cosa.'
    },
    cardio: {
      name: 'Guadalupe S.',
      meta: '67 años, San Antonio TX',
      text: 'Después de que me pusieron un stent me prometí entender mi cuerpo. La conexión entre azúcar, inflamación y corazón que explica el capítulo 6... eso debería saberlo todo el mundo. Se lo regalé a mis 3 hijos.'
    }
  };
  return <section className="py-16 md:py-24 px-4 bg-cream" data-id="element-378">
      <div className="max-w-4xl mx-auto" data-id="element-379">
        <div className="text-center mb-12" data-id="element-380">
          <span className="inline-block text-cta font-bold tracking-widest text-sm uppercase mb-4" data-id="element-381">
            LECTORES
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-navy leading-tight mb-4" data-id="element-382">
            Historias reales
          </h2>
          <div className="flex justify-center gap-1 text-gold text-xl" data-id="element-383">
            <span data-id="element-384">★</span>
            <span data-id="element-385">★</span>
            <span data-id="element-386">★</span>
            <span data-id="element-387">★</span>
            <span data-id="element-388">★</span>
          </div>
        </div>

        <div className="bg-white rounded-2xl shadow-sm border border-navy/5 overflow-hidden" data-id="element-389">
          {/* Tabs */}
          <div className="flex flex-wrap border-b border-navy/5 bg-cream-dark/30" data-id="element-390">
            <button onClick={() => setActiveTab('prediabetes')} className={`flex-1 min-w-[120px] py-4 px-2 text-sm font-bold uppercase tracking-wider transition-colors ${activeTab === 'prediabetes' ? 'bg-white text-cta border-b-2 border-cta' : 'text-navy/60 hover:text-navy hover:bg-white/50'}`} data-id="element-391">
              Prediabetes
            </button>
            <button onClick={() => setActiveTab('diabetes')} className={`flex-1 min-w-[120px] py-4 px-2 text-sm font-bold uppercase tracking-wider transition-colors ${activeTab === 'diabetes' ? 'bg-white text-cta border-b-2 border-cta' : 'text-navy/60 hover:text-navy hover:bg-white/50'}`} data-id="element-392">
              Diabetes tipo 2
            </button>
            <button onClick={() => setActiveTab('familiar')} className={`flex-1 min-w-[120px] py-4 px-2 text-sm font-bold uppercase tracking-wider transition-colors ${activeTab === 'familiar' ? 'bg-white text-cta border-b-2 border-cta' : 'text-navy/60 hover:text-navy hover:bg-white/50'}`} data-id="element-393">
              Prevención familiar
            </button>
            <button onClick={() => setActiveTab('prevencion')} className={`flex-1 min-w-[120px] py-4 px-2 text-sm font-bold uppercase tracking-wider transition-colors ${activeTab === 'prevencion' ? 'bg-white text-cta border-b-2 border-cta' : 'text-navy/60 hover:text-navy hover:bg-white/50'}`} data-id="element-394">
              Prevención
            </button>
            <button onClick={() => setActiveTab('cardio')} className={`flex-1 min-w-[120px] py-4 px-2 text-sm font-bold uppercase tracking-wider transition-colors ${activeTab === 'cardio' ? 'bg-white text-cta border-b-2 border-cta' : 'text-navy/60 hover:text-navy hover:bg-white/50'}`} data-id="element-395">
              Cardiovascular
            </button>
          </div>

          {/* Content */}
          <div className="p-8 md:p-12 min-h-[250px] flex flex-col justify-center" data-id="element-396">
            <div className="mb-6" data-id="element-397">
              <div className="flex gap-1 text-gold text-sm mb-4" data-id="element-398">
                <span data-id="element-399">★</span>
                <span data-id="element-400">★</span>
                <span data-id="element-401">★</span>
                <span data-id="element-402">★</span>
                <span data-id="element-403">★</span>
              </div>
              <p className="text-xl md:text-2xl font-serif italic text-navy leading-relaxed" data-id="element-404">
                "{testimonials[activeTab].text}"
              </p>
            </div>
            <div className="mt-auto pt-6 border-t border-navy/5 flex items-center gap-4" data-id="element-405">
              {activeTab === 'prediabetes' && <img src="https://cdn.magicpatterns.com/uploads/3devFFzcCNmXCCYsWr36h5/Maria_Elena_R_-_58_anos.png" alt="María Elena R." className="w-12 h-12 rounded-full object-cover border-2 border-gold/30 shrink-0" data-id="element-406" />}
              {activeTab === 'diabetes' && <img src="https://cdn.magicpatterns.com/uploads/kT5uP3UNYF6wtQ7yLcKr3E/Carlos_M_-_62_anos.png" alt="Carlos M." className="w-12 h-12 rounded-full object-cover border-2 border-gold/30 shrink-0" data-id="element-407" />}
              {activeTab === 'familiar' && <img src="https://cdn.magicpatterns.com/uploads/uGjjvVizvvpnFJoocrYvNR/Ana_Lucia_V_-_44_anos.png" alt="Ana Lucía V." className="w-12 h-12 rounded-full object-cover border-2 border-gold/30 shrink-0" data-id="element-408" />}
              {activeTab === 'prevencion' && <img src="https://cdn.magicpatterns.com/uploads/reGEpbwEruLKBvzXjKBfcd/Roberto_D_-_51_anos.png" alt="Roberto D." className="w-12 h-12 rounded-full object-cover border-2 border-gold/30 shrink-0" data-id="element-409" />}
              {activeTab === 'cardio' && <img src="https://cdn.magicpatterns.com/uploads/jcEDgnFU8bYr581KqXReGE/Guadalupe_S_-_67_anos.png" alt="Guadalupe S." className="w-12 h-12 rounded-full object-cover border-2 border-gold/30 shrink-0" data-id="element-410" />}
              <div data-id="element-411">
                <p className="font-bold text-navy uppercase tracking-wider text-sm" data-id="element-412">
                  {testimonials[activeTab].name}
                </p>
                <p className="text-navy/60 text-sm font-sans" data-id="element-413">
                  {testimonials[activeTab].meta}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}